var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0392,
    cy: 79.9501,
    r: 10.92,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.8009,
    cy: 79.9501,
    r: 10.92,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5607,
    cy: 79.9501,
    r: 10.92,
    stroke: "white",
    strokeWidth: 2.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24023 72.1499V49.9199L14.0402 40.9499L21.8402 49.9199V72.1499M39.0002 72.1499V29.6399L46.8002 20.6699L54.6002 29.6399V72.1499M71.7602 72.1499V12.8699L79.5602 3.8999L87.3602 12.8699V72.1499",
    stroke: "white",
    strokeWidth: 3.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.808dca98ed79bb1e387faf33ba3f5e5f.svg";
export { ForwardRef as ReactComponent };